import { render, staticRenderFns } from "./curSale-delivery-detail.vue?vue&type=template&id=14a0e684&scoped=true"
import script from "./curSale-delivery-detail.vue?vue&type=script&lang=js"
export * from "./curSale-delivery-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0e684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a0e684')) {
      api.createRecord('14a0e684', component.options)
    } else {
      api.reload('14a0e684', component.options)
    }
    module.hot.accept("./curSale-delivery-detail.vue?vue&type=template&id=14a0e684&scoped=true", function () {
      api.rerender('14a0e684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/curSale-management/curSale-delivery/curSale-delivery-detail.vue"
export default component.exports